// extracted by mini-css-extract-plugin
export default {"btnWrapper":"PDFModal_btnWrapper__phDb3","downloadBtn":"PDFModal_downloadBtn__ICOjt"};